export default "__VITE_ASSET__BNYDBG5l__"